// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__302qp","log":"ModalInventoryLogs_log__35ptS","date":"ModalInventoryLogs_date__1XNNw","userName":"ModalInventoryLogs_userName__3YhXy"};